export default __webpack_public_path__ + "static/media/editenable.d52b8e22.svg";